import { message } from 'antd'
import { isAfter, isValid } from 'date-fns'
import format from 'date-fns/format'

export const formatBytes = (bytes) => {
  const marker = 1024 // Change to 1000 if required
  const decimal = 2 // Change as required
  const kiloBytes = marker // One Kilobyte is 1024 bytes
  const megaBytes = marker * marker // One MB is 1024 KB
  const gigaBytes = marker * marker * marker // One GB is 1024 MB

  // return bytes if less than a KB
  if (bytes < kiloBytes) return `${bytes} Bytes`
  // return KB if less than a MB
  if (bytes < megaBytes) return `${(bytes / kiloBytes).toFixed(decimal)} KB`
  // return MB if less than a GB
  if (bytes < gigaBytes) return `${(bytes / megaBytes).toFixed(decimal)} MB`
  // return GB if less than a TB
  return `${(bytes / gigaBytes).toFixed(decimal)} GB`
}

export const showErrors = (error) => {
  const errors = error.response.data.errors
  if (errors) {
    Object.entries(errors).forEach(([key, val]) => {
      message.error(val)
    })
  } else {
    const data = error.response?.data
    message.error(data?.error ?? data?.message)
  }
}

export const compareText = (a, b) => {
  return a.localeCompare(b)
}

export const compareDate = (a, b) => {
  return isAfter(new Date(a), new Date(b)) ? 0 : 1
}

export const compareNumber = (a, b) => {
  return a - b
}

export const formatDateTime = (date) => {
  if (date == null) {
    return ''
  }

  const d = new Date(date)
  if (isValid(d)) {
    return format(new Date(date), 'MMM d, yyyy H:mm z')
  }

  return 'Invalid Date'
}

export const toDateString = (date) => {
  if (date == null) {
    return ''
  }

  const d = new Date(date)
  if (isValid(d)) {
    return format(new Date(date), 'MMM d, yyyy')
  }

  return 'Invalid Date'
}

export const backendUrl = (path) => {
  // trim leading slash
  let _path = path
  while (_path.charAt(0) === '/') {
    _path = _path.substring(1)
  }

  const baseUrl = import.meta.env.VITE_BASE_APP_URL ?? window.location.origin

  return `${baseUrl}/${_path}`
}

export const clipboard = (value) => {
  if (window.isSecureContext) {
    navigator.clipboard.writeText(value)
  } else {
    console.info(
      'Clipboard copy only available only in secure contexts (HTTPS)'
    )
  }
}

const displayNameFormatter = new Intl.DisplayNames(['en'], { type: 'region' })
export const countryCodeToName = (code) => {
  try {
    return displayNameFormatter.of(code)
  } catch (e) {
    return ''
  }
}

export const countDown = (seconds, excCallback, countdownCallback) => {
  let count = seconds
  const id = setInterval(() => {
    count = count - 1
    countdownCallback(count)
    if (count <= 0) {
      clearInterval(id)
      excCallback()
    }
  }, 1000)
}
